import moment from "moment";
import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import SimpleBar from "simplebar-react";
import StylistLocation from "./stylistLocation";
import MomentTimezone from "moment-timezone";
const ServiceOrderHistory = ({ OrderHistory, userLocation }) => {
  console.log(OrderHistory, "order History");
  const stylistLocation =
    OrderHistory?.find(item => item.coordinates)?.coordinates || null;
  const RenderOrderHistory = OrderHistory => {
    return (
      <SimpleBar>
        <div className="">
          <ul className="verti-timeline list-unstyled mx-2">
            {OrderHistory &&
              OrderHistory?.map((log, indx) => {
                return (
                  <li className="event-list" key={indx}>
                    <div className="event-timeline-dot">
                      <i className="bx bx-right-arrow-circle font-size-18"></i>
                    </div>
                    <div className="d-flex">
                      <div className="me-2 d-flex">
                        <h5 className="font-size-14">
                          {log.time && moment(log.time).format("DD-MM-YYYY")}
                          <br />
                          <span className="font-size-12">
                            {log?.time && MomentTimezone.tz(log.time,"Asia/Kolkata").format(" hh:mm A")}
                            
                          </span>
                        </h5>
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="">{log?.status}</h6>
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </SimpleBar>
    );
  };
  return (
    <div className="">
      <Row>
        <Col>
          <Card className="">
            <h5 className="p-3 mb-0">Order History</h5>
            <CardBody className="border-top border-3">
              <div className="">
                {OrderHistory?.length > 0
                  ? RenderOrderHistory(OrderHistory)
                  : "History is not available"}
              </div>
            </CardBody>
          </Card>
        </Col>
        {stylistLocation && (
          <Col md={6}>
            <Card className="">
              <h5 className="p-3 mb-0">Stylist Location</h5>
              <CardBody className="border-top border-3">
                <StylistLocation
                  orderHistory={OrderHistory}
                  userLocation={userLocation}
                />
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ServiceOrderHistory;
